import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFromDetails'
})
export class DateFromDetailsPipe implements PipeTransform {

  transform(value: any): string {
   if (value) {
    return (
      value.weekDay +
      ', ' +
      value.month +
      ' ' +
      value.day +
      ', ' +
      value.year +
      ' at ' +
      value.hour +
      ':' +
      value.minute +
      ' ' +
      value.meridian
    );
   }
   return value; 
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-from-details.pipe.ts